"use client";
import { Environment as g } from "@coolblue-development/constants";
import { datadogLogs as t } from "@datadog/browser-logs";
import { useRef as w } from "react";
const P = ({
  clientToken: o,
  service: r,
  serviceVersion: e,
  forwardReports: n,
  isInternal: u = !1,
  environment: s = g.DEVELOPMENT
}) => {
  const f = "datadoghq.eu", c = w(!1);
  if (typeof window > "u") return null;
  const E = (i) => {
    var l;
    const d = new Date(i.date).toISOString().slice(11, 23);
    return (u || s === g.DEVELOPMENT) && (console.groupCollapsed(
      `%cDatadog logging%c: ${i.message}%c @ ${d}`,
      "color: #774aa4; font-weight: bold;",
      "color: inherit; font-weight: normal;",
      "color: gray; font-weight: normal;"
    ), console.log(i), console.groupEnd()), !(s === g.DEVELOPMENT || ((l = i.http) == null ? void 0 : l.status_code) === 0);
  };
  return c.current || (t.init({
    clientToken: o,
    site: f,
    forwardErrorsToLogs: !0,
    sessionSampleRate: 100,
    service: r,
    version: e,
    env: s,
    forwardReports: n,
    beforeSend: E
  }), c.current = !0), null;
}, p = a();
function S() {
  return p;
}
function a(o = {}) {
  return {
    info(r, e) {
      t.logger.info(r, { ...o, ...e });
    },
    debug(r, e) {
      t.logger.debug(r, { ...o, ...e });
    },
    warning(r, e, n) {
      t.logger.warn(r, { ...o, ...e }, n);
    },
    error(r, e, n) {
      t.logger.error(r, { ...o, ...n }, e);
    },
    withEnricher(r) {
      return a({ ...o, ...r.enrich() });
    }
  };
}
var h = /* @__PURE__ */ ((o) => (o.DEVELOPMENT = "development", o.TESTING = "testing", o.ACCEPTANCE = "acceptance", o.PRODUCTION = "production", o))(h || {});
export {
  h as Environment,
  P as PageLogger,
  S as getLogger
};
